import React, { FC, HTMLAttributes, ReactNode } from 'react';

import { Col, Row, SVG } from '@nord/ui';

export interface IBaseProps extends HTMLAttributes<HTMLDivElement> {
  text?: ReactNode;
}

interface IIcon {
  icon: string;
  iconTitle: string;
  useSVG?: boolean;
  large?: boolean;
}

interface INoIcon {
  icon?: null;
  iconTitle?: null;
  useSVG?: null;
  large?: null;
}

export type INoItemsProps = IBaseProps & (IIcon | INoIcon);

/**
 * @deprecated use NoResultsItems or NoSearchedItems
 */
const NoItems: FC<INoItemsProps> = ({
  icon,
  text,
  iconTitle,
  useSVG = true,
  children,
  large = false,
  ...rest
}) => (
  <Row justify="center" {...rest}>
    <Col className="text-center">
      {icon &&
        (useSVG ? (
          <SVG
            src={icon}
            title={iconTitle}
            width={large ? 96 : 32}
            height={large ? 96 : 32}
            className="text-grey-lighter mt-5 mb-4"
          />
        ) : (
          <img
            src={icon}
            alt={iconTitle}
            className="mt-5 mb-4 inline"
            style={{ width: '96px', height: '96px' }}
          />
        ))}
      {text && (
        <div data-testid="noitems-text" className="nord-text text-small leading-normal text-grey">
          {text}
        </div>
      )}
      {children}
    </Col>
  </Row>
);

export default NoItems;
